var MembersStrings = {
    membersPageSubtitleText: function (totalCount, limit) {
        return totalCount + " out of " + limit;
    },
    addMembersModalDescription: function () {
        return "Enter the email address of each member separated by commas, newlines or spaces. We'll send them an email invitation to access their benefits.";
    },
    addMembersModalDescriptionPlusLimitation: function (remaining, totalCount) {
        return "You have " + remaining + " out of " + totalCount + " spots left on your Team plan.";
    },
    limitationErrorBannerTitle: function () {
        return "You've exceeded the maximum number of members";
    },
    limitationErrorBannerDescription: function (remaining) {
        return "You can only add " + remaining + " members to your Team plan. Contact sales to upgrade to the Enterprise plan which offers unlimited spots.";
    },
    membersLimitModalTitle: function () { return 'Upgrade to add members'; },
    membersLimitModalDescription: function (limit) {
        return "You have a limit of " + limit + " members for the Small Team plan. To add more members, contact sales to upgrade to the Corporate Ordering plan.";
    },
    membersLimitModalContactSalesButtonText: function () { return 'Contact Sales'; },
    membersLimitModalContactCancelButtonText: function () { return 'Cancel'; },
};
export default MembersStrings;
